import { render, staticRenderFns } from "./CustomerCustomerEmailHistory.vue?vue&type=template&id=7a3ad8a0"
import script from "./CustomerCustomerEmailHistory.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerEmailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports